// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__ErLr5","label":"Labeled_label__TlJhE","divider":"Labeled_divider__3K8eY"};